module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-LightItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-LightItalic-webfont.ttf
// module id = 1632
// module chunks = 0